import React, { useEffect, useState } from 'react';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import { Close as CloseIcon } from '@mui/icons-material';
import moment from 'moment';

// Set the PDF.js worker path
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PdfModalProps {
    base64Pdf: string;
    visible: boolean;
    payDate: string;
    handleClose: () => void;
}

const PdfModal = (props: PdfModalProps) => {
  const [containerWidth, setContainerWidth] = useState<number>(0);
    // const [numPages, setNumPages] = useState<number | null>(0);

  // Function to get the number of pages when PDF loads
  // const onDocumentLoadSuccess = ({ numPages }: any) => {
  //   setNumPages(numPages);
  // };

  // Get the width of the container for responsive PDF scaling
  useEffect(() => {
    const handleResize = () => {
      const container = document.getElementById('pdf-container');
      if (container) {
        setContainerWidth(container.offsetWidth);
      }
    };

    handleResize(); // Set initially
    window.addEventListener('resize', handleResize); // Update on resize

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // function getRandomFileName() {
  //   var timestamp = new Date().toISOString().replace(/[-:.]/g,"");  
  //   var random = ("" + Math.random()).substring(2, 8); 
  //   var random_number = timestamp+random;  
  //   return random_number;
  // }

  const downloadAttachment = () => {
    const link = document.createElement('a');

    link.href = `data:pdf;base64,${props.base64Pdf}`;
    link.target = '_blank';
    link.download = "Payslips - "+ moment(props.payDate).format("DD-MM-YYYY") +'.pdf';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  }

  return (
    <Dialog 
      open={props.visible} 
      onClose={props.handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ style: { maxHeight: '80vh'}}}
    >
      {/* Dialog Title with a Close Button */}
      <DialogTitle>
        Payslip
        <IconButton
          aria-label="close"
          onClick={props.handleClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers id="pdf-container" style={{ position: 'relative', padding: 0,  overflowX: 'hidden' }}>
        {/* Show loading spinner while the PDF is loading */}
        {props.base64Pdf.length == 0 && (
          <div style={{ display: 'flex', margin: '10px', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </div>
        )}

        {/* Show the PDF Document once loaded */}
        {props.base64Pdf.length > 0 && (
          <Document
            file={`data:application/pdf;base64,${props.base64Pdf}`}
          >
            <Page pageNumber={1} width={containerWidth} renderTextLayer={false} renderAnnotationLayer={false} />
          </Document>
        )}
      </DialogContent> 

      <DialogActions>
          <Button 
            onClick={() => downloadAttachment()}  
            variant="contained"
            color='primary'
          >
            Download
          </Button>
          <Button 
            onClick={props.handleClose}  
            variant="contained"
            color='primary'
          >
            Close
          </Button>
      </DialogActions>  
    </Dialog>
  );
};

export default PdfModal;